import {NgModule} from '@angular/core';
// import {SubscriptionListComponent} from './components/subscription-list/subscription-list.component';
import {
  // addNavMenuItem,
  SharedModule,
} from '@vendure/admin-ui/core';
import {TranslatePipe} from './pipes/translate.pipe';
import {CurrencyTranslate} from './pipes/currencyTranslate.pipe';
import {DeliverState} from './pipes/deliverState.pipe';
import {FormatDatePipe} from './pipes/formatDate.pipe';

const comps = [TranslatePipe, CurrencyTranslate, DeliverState, FormatDatePipe];

@NgModule({
  imports: [SharedModule],
  declarations: comps,
  exports: comps,
  providers: [
    // addNavMenuItem(
    //   {
    //     id: 'after-sale-management',
    //     label: '售后列表',
    //     routerLink: ['/extensions/after-sale/list'],
    //     icon: 'calendar',
    //     requiresPermission: 'AfterSaleOperate',
    //   },
    //   'sales',
    // ),
    // addNavMenuItem(
    //   {
    //     id: 'channel-address',
    //     label: '退货地址管理',
    //     routerLink: ['/extensions/after-sale/channel-address'],
    //     icon: 'calendar',
    //     requiresPermission: 'AfterSaleOperate',
    //   },
    //   'sales',
    // ),
  ],
})
export class AfterSaleUiSharedModule {}
